// - Filters Lotes
export default [
    {
        field: 'supervisor_g_user_id',
        value: [],
        label: 'Supervisor',
        options: [],
    },
]
